import {css} from '@emotion/css';
import {VosLogoLaptop} from 'Shared/backend/icons/VosLogoLaptop';
import { theme } from 'Shared/ThemeProvider';

export const utilityPageStyle = () => css(theme().root, {
	maxWidth: 600,
	margin: '0 auto',
	display: 'flex',
	flexDirection: 'column',

	header: {
		svg: {
			width: 200,
			alignSelf: 'center'
		},

		'.tick': {
			color: 'green',
			fontSize: '7em'
		}
	}
});


export function Banner()
{
	const bannerStyle = css({
		svg: {
			width: 80,
			alignSelf: 'center'
		}
	});

	return (
		<header class={bannerStyle}>
			<VosLogoLaptop />
		</header>
	);
}


